import { createFileRoute } from "@tanstack/react-router";
import { PlateStatus } from "../../app/views/elisa/plateStatus";

export const Route = createFileRoute("/elisa/status")({
  component: PlateStatus,
});
